import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

export interface Country {
    code: string;
    name: string;
}

export interface CountryState {
    code: string;
    name: string;
}

export interface PostalCodePatterns {
    [index: string]: string[];
}

const countryApi = createApi({
    reducerPath: 'lokaliseInternal_country',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getCountries: builder.query<Country[], void>({
            query: () => ({
                method: 'GET',
                url: '/countries',
            }),
        }),
        getUsCountryStates: builder.query<CountryState[], void>({
            query: () => ({
                method: 'GET',
                url: '/countries/US/states',
            }),
        }),
        getPostalCodePatterns: builder.query<PostalCodePatterns, void>({
            query: () => ({
                method: 'GET',
                url: '/countries/postal_codes',
            }),
        }),
    }),
});

export default countryApi;

export const { useGetCountriesQuery, useGetUsCountryStatesQuery, useGetPostalCodePatternsQuery } = countryApi;
